export const PIP_WINDOW_SIZE_KEY = 'maple-log:pip-window-size'

export interface PipWindowSize { width: number; height: number }

function validSize(value: unknown): value is PipWindowSize {
  if (!value || typeof value !== 'object') return false
  const { width, height } = value as PipWindowSize
  return Number.isSafeInteger(width) && width > 0 && Number.isSafeInteger(height) && height > 0
}

export function readPipWindowSize(): PipWindowSize | null {
  try {
    const value: unknown = JSON.parse(window.localStorage.getItem(PIP_WINDOW_SIZE_KEY) ?? 'null')
    return validSize(value) ? { width: value.width, height: value.height } : null
  } catch { return null }
}

export function savePipWindowSize(size: PipWindowSize): boolean {
  if (!validSize(size)) return false
  try {
    window.localStorage.setItem(PIP_WINDOW_SIZE_KEY, JSON.stringify({ width: size.width, height: size.height }))
    return true
  } catch { return false }
}
